"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var isThemeColor = function (color) { return /^color_\d+$/.test(color); };
var getFromColorMap = function (rawColor, colorsMap) {
    var _a = rawColor.split('_'), themeColorIndex = _a[1];
    var i = parseInt(themeColorIndex, 10);
    return typeof i === 'number' && isNaN(i) === false ? colorsMap[i] : rawColor;
};
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'styleProperties', 'siteColors'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, styleProperties = _a.styleProperties, siteColors = _a.siteColors;
    var signatureSize = styleProperties.signatureSize, signatureColorProp = styleProperties.signatureColor;
    return {
        label: compData.titleText,
        clearButtonText: compData.clearButtonText,
        required: compProps.required || false,
        isDisabled: compProps.isDisabled || false,
        direction: compProps.direction,
        signatureSize: signatureSize.endsWith('px')
            ? signatureSize.slice(0, -2)
            : signatureSize,
        signatureColor: isThemeColor(signatureColorProp)
            ? getFromColorMap(signatureColorProp, siteColors)
            : signatureColorProp,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compProps'], function (_a, cssVars) {
    var compProps = _a.compProps;
    var direction = compProps.direction, titlePaddingStart = compProps.titlePaddingStart, titleMarginBottom = compProps.titleMarginBottom;
    return __assign(__assign({}, cssVars), { '--dir': direction, '--labelPadding': direction === 'rtl'
            ? "0 " + titlePaddingStart + "px 0 0"
            : "0 0 0 " + titlePaddingStart + "px", '--labelMarginBottom': titleMarginBottom + "px" });
});
//# sourceMappingURL=SignatureInput.js.map